import { requestService } from '@/services/apiRequests/request.service';
import { LocaleService } from '@/services/storage.service';

export default {
    namespaced: true,
    state: {
        ContractInfo: {},
        ContactList: [],
        ContractListLoading: false,
        ContractList: [],
        ContractLength: 0,
        ObjectListLoading: false,
        ObjectList: [],
        ObjectLength: 0,
        ContractRid: null,
        ObjList: [],
        AdresList: [],
        EngineerList: [],
        ExploitAreaList: [],
        ExploitDistrictList: [],
        DistrictList: [],
        Filter: null,
        SelectedContract: null,
        ObjectPagination: { itemsPerPage: 3 },
        ContractPagination: { itemsPerPage: 3 },
        KSKFullInfo: null,
        KSKContacts: [],
        KSKHousesPagination: { itemsPerPage: 10 },
        KSKHousesLoading: false,
        KSKHousesLenght: 0,
        KSKHousesList: [],
        ContactTypes: []
    },
    mutations: {
        setContactTypes(state, ContactTypes) {
            state.ContactTypes = ContactTypes;
        },
        setKSKHousesLoading(state, KSKHousesLoading) {
            state.KSKHousesLoading = KSKHousesLoading;
        },
        setKSKHousesLenght(state, KSKHousesLenght) {
            state.KSKHousesLenght = KSKHousesLenght;
        },
        setKSKHousesList(state, KSKHousesList) {
            state.KSKHousesList = KSKHousesList;
        },
        setKSKHousesPagination(state, KSKHousesPagination) {
            state.KSKHousesPagination = KSKHousesPagination;
        },
        setKSKFullInfo(state, KSKFullInfo) {
            state.KSKFullInfo = KSKFullInfo;
        },
        setKSKContacts(state, KSKContacts) {
            state.KSKContacts = KSKContacts;
        },
        setContractPagination(state, ContractPagination) {
            state.ContractPagination = ContractPagination;
        },
        setObjectPagination(state, ObjectPagination) {
            state.ObjectPagination = ObjectPagination;
        },
        setSelectedContract(state, SelectedContract) {
            state.SelectedContract = SelectedContract;
            state.AdresList = [];
            state.EngineerList = [];
            state.ExploitAreaList = [];
            state.ExploitDistrictList = [];
            state.DistrictList = [];
            state.Filter = null;
        },
        setFilter(state, Filter) {
            state.Filter = Filter;
        },
        setObjList(state, ObjList) {
            state.ObjList = ObjList;
        },
        setAdresList(state, AdresList) {
            state.AdresList = AdresList;
        },
        setEngineerList(state, EngineerList) {
            state.EngineerList = EngineerList;
        },
        setExploitAreaList(state, ExploitAreaList) {
            state.ExploitAreaList = ExploitAreaList;
        },
        setExploitDistrictList(state, ExploitDistrictList) {
            state.ExploitDistrictList = ExploitDistrictList;
        },
        setDistrictList(state, DistrictList) {
            state.DistrictList = DistrictList;
        },
        setObjectListLoading(state, ObjectListLoading) {
            state.ObjectListLoading = ObjectListLoading;
        },
        setContractListLoading(state, ContractListLoading) {
            state.ContractListLoading = ContractListLoading;
        },
        setContractRid(state, ContractRid) {
            state.ContractRid = ContractRid;
        },
        setContractInfo(state, ContractInfo) {
            state.ContractInfo = ContractInfo;
        },
        setContactList(state, ContactList) {
            state.ContactList = ContactList;
        },
        setContractList(state, ContractList) {
            state.ContractList = ContractList;
        },
        setContractLength(state, ContractLength) {
            state.ContractLength = ContractLength;
        },
        setObjectList(state, ObjectList) {
            state.ObjectList = ObjectList;
        },
        setObjectLength(state, ObjectLength) {
            state.ObjectLength = ObjectLength;
        }
    },
    getters: {},
    actions: {
        async getContractInfo({ commit, state }, { ContractRid }) {
            try {
                commit('setContractInfo', {});
                commit('setContactList', []);
                const res = await requestService.GetContractInfo(ContractRid);
                if (res.successfull) {
                    if (res.data && res.data.isas_contractor_data) commit('setContractInfo', res.data.isas_contractor_data[0]);
                    if (res.data && res.data.isas_contractor_contacts) commit('setContactList', res.data.isas_contractor_contacts);
                }
            } catch (e) {
                console.error(e);
            }
        },
        async getContractContracts({ commit, state }, { ContractRid, iLimit, iOffset }) {
            try {
                commit('setContractListLoading', true);
                commit('setContractList', []);
                commit('setContractLength', 0);
                const res = await requestService.GetContractContracts(ContractRid, iLimit, iOffset);
                if (res.successfull) {
                    if (res.data && res.data.isas_contracts) commit('setContractList', res.data.isas_contracts);
                    if (res.data && res.data.pagination && res.data.pagination.row_count) commit('setContractLength', res.data.pagination.row_count);
                }
                commit('setContractListLoading', false);
            } catch (e) {
                console.error(e);
            }
        },
        async getContractObjects({ commit, state }, { ContractRid, iLimit, iOffset }) {
            try {
                commit('setObjectListLoading', true);
                commit('setObjectList', []);
                commit('setObjectLength', 0);

                let res;
                if (state.Filter) {
                    const locale = LocaleService.getLocale();
                    // определяем язык интерфейса
                    const JSONToSend = {
                        locale: locale === 'ru' ? '___ru' : '___kz'
                    };
                    // если задан фильтр
                    if (state.Filter) {
                        JSONToSend.where = state.Filter.where;
                    }
                    res = await requestService.GetContractObjects(ContractRid, iLimit, iOffset, JSONToSend);
                } else {
                    res = await requestService.GetContractObjects(ContractRid, iLimit, iOffset);
                }
                if (res.successfull) {
                    if (res.data && res.data.isas_contract_objects) commit('setObjectList', res.data.isas_contract_objects);
                    if (res.data && res.data.pagination && res.data.pagination.row_count) commit('setObjectLength', res.data.pagination.row_count);
                }
                commit('setObjectListLoading', false);
            } catch (e) {
                console.error(e);
            }
        },
        async loadFilters({ commit }, { ContractRid, KSKRid }) {
            try {
                commit('setAdresList', []);
                commit('setDistrictList', []);
                commit('setEngineerList', []);
                commit('setExploitAreaList', []);
                commit('setExploitDistrictList', []);
                commit('setObjList', []);
                let res;
                if (ContractRid !== 0) {
                    res = await requestService.GetObjFilterParams(ContractRid);
                } else {
                    res = await requestService.getKSKFilterList(KSKRid);
                }
                if (res.successfull) {
                    if (res.data && res.data.isas_addresses) commit('setAdresList', res.data.isas_addresses);
                    if (res.data && res.data.isas_districts) commit('setDistrictList', res.data.isas_districts);
                    if (res.data && res.data.isas_engineers) commit('setEngineerList', res.data.isas_engineers);
                    if (res.data && res.data.isas_exploit_areas) commit('setExploitAreaList', res.data.isas_exploit_areas);
                    if (res.data && res.data.isas_exploit_districts) commit('setExploitDistrictList', res.data.isas_exploit_districts);
                    if (res.data && res.data.isas_objects) {
                        commit('setObjList', res.data.isas_objects);
                    }
                }
            } catch (e) {
                console.error(e);
            }
        },
        async getKSKFullInfo({ commit, state }, { KSKId }) {
            try {
                commit('setKSKFullInfo', {});
                commit('setKSKContacts', []);
                const res = await requestService.getKSKFullInfo(KSKId);
                if (res.successfull) {
                    if (res.data && res.data.isas_ksk_data) commit('setKSKFullInfo', res.data.isas_ksk_data[0]);
                    if (res.data && res.data.isas_ksk_contacts) commit('setKSKContacts', res.data.isas_ksk_contacts);
                }
            } catch (e) {
                console.error(e);
            }
        },
        async getKSKHouses({ commit, state }, { KSKId, iLimit, iOffset }) {
            try {
                commit('setKSKHousesLoading', true);
                commit('setKSKHousesList', []);
                commit('setKSKHousesLenght', 0);

                let res;
                if (state.Filter) {
                    const locale = LocaleService.getLocale();
                    // определяем язык интерфейса
                    const JSONToSend = {
                        locale: locale === 'ru' ? '___ru' : '___kz'
                    };
                    // если задан фильтр
                    if (state.Filter) {
                        JSONToSend.where = state.Filter.where;
                    }
                    //console.log(JSONToSend);
                    res = await requestService.getKSKHouses(iLimit, iOffset, JSONToSend);
                } else {
                    res = await requestService.getKSKHouses(iLimit, iOffset);
                }
                if (res && res.isas_ksk_houses_period) commit('setKSKHousesList', res.isas_ksk_houses_period);
                if (res && res.pagination && res.pagination.row_count) commit('setKSKHousesLenght', res.pagination.row_count);
                commit('setKSKHousesLoading', false);
            } catch (e) {
                console.error(e);
            }
        },
        async getContactTypes({ commit }) {
            try {
                commit('setContactTypes', []);
                const res = await requestService.getContactTypes();
                if (res.successfull) {
                    if (res.data && res.data.isas_contact_types) commit('setContactTypes', res.data.isas_contact_types);
                }
            } catch (e) {
                console.error(e);
            }
        },
        async updateKSKInfo({ commit }, { iksk_rid, nvcKSKData }) {
            try {
                const res = await requestService.updateKSKInfo(iksk_rid, nvcKSKData);
                return res;
            } catch (e) {
                console.error(e);
            }
        },
        async updateContacts({ commit }, { iContractor_rid, nvcContacts }) {
            try {
                const res = await requestService.updateContacts(iContractor_rid, nvcContacts);
                return res;
            } catch (e) {
                console.error(e);
            }
        }
    }
};
